import { defineMessages } from '@formatjs/intl';

const messages = defineMessages({
	title: {
		id: 'gift.card.howItWorks.title',
		defaultMessage: 'How it works',
		description: 'Title for the section explaining how to give a Calm gift card',
	},
	personalizeStepTitle: {
		id: 'gift.card.howItWorks.personalize.title',
		defaultMessage: '1. Personalize',
		description: 'The first step to give a gift card is to personalize the gift card',
	},
	personalizeStepDescription: {
		id: 'gift.card.howItWorks.personalize.description',
		defaultMessage: 'Select a calming card design and craft a message to make the gift your own',
		description: 'The first step to give a gift card is to personalize the gift card',
	},
	purchaseStepTitle: {
		id: 'gift.card.howItWorks.purchase.title',
		defaultMessage: '2. Purchase',
		description: 'The second step to give a gift card is to purchase the gift card',
	},
	purchaseStepDescription: {
		id: 'gift.card.howItWorks.purchase.description',
		defaultMessage: 'Buy Calm for the loved one in your life',
		description: 'The second step to give a gift card is to purchase the gift card',
	},
	sendStepTitle: {
		id: 'gift.card.howItWorks.send.title',
		defaultMessage: '3. Send',
		description: 'The third step to give a gift card is to send the gift card',
	},
	sendStepDescription: {
		id: 'gift.card.howItWorks.send.description',
		defaultMessage: "We'll deliver your gift via email on the date you select!",
		description: 'The third step to give a gift card is to send the gift card',
	},
});

export default messages;
